var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStylus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02119 19.9229C4.73519 19.9806 4.49186 19.9092 4.29119 19.7087C4.09069 19.508 4.01927 19.2647 4.07694 18.9787L4.74994 15.7229L8.27694 19.2499L5.02119 19.9229ZM8.27694 19.2499L4.74994 15.7229L15.7384 4.7344C16.0448 4.42807 16.4236 4.2749 16.8749 4.2749C17.3263 4.2749 17.7051 4.42807 18.0114 4.7344L19.2654 5.9884C19.5718 6.29474 19.7249 6.67357 19.7249 7.1249C19.7249 7.57624 19.5718 7.95507 19.2654 8.2614L8.27694 19.2499ZM16.4519 5.44215L6.35194 15.5229L8.47694 17.6479L18.5577 7.5479C18.673 7.43257 18.7307 7.2884 18.7307 7.1154C18.7307 6.94224 18.673 6.79799 18.5577 6.68265L17.3172 5.44215C17.2019 5.32682 17.0576 5.26915 16.8844 5.26915C16.7114 5.26915 16.5673 5.32682 16.4519 5.44215Z",
    fill: "#ABB2CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStylus);
export default __webpack_public_path__ + "static/media/stylus.9a66750938e6902e1f0b51d59afdd638.svg";
export { ForwardRef as ReactComponent };